import React from 'react'
import { TextField } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'

function ButtonCheckbox(props) {
  let errorMessage = null
  let errorStatus = false
  const {
    type,
    input,
    label,
    placeholder,
    disabled,
    required,
    disableLabelMove,
    inputProps,
    onKeyDown,
    meta: { submitError, touched, error },
  } = props

  if (touched && (error || submitError)) {
    errorStatus = true
    errorMessage = error || submitError
  }

  return (
    <div className="form-group">
      <FormControl component="div" fullWidth error={errorStatus}>
        <TextField
          {...input}
          {...inputProps}
          error={errorStatus}
          type={type}
          label={label}
          disabled={disabled}
          required={required}
          placeholder={placeholder}
          className="form-group"
          InputLabelProps={{
            shrink: disableLabelMove,
          }}
          onKeyDown={onKeyDown}
          style={{
            display: 'none',
          }}
        />
        {errorStatus && <FormHelperText>{errorMessage}</FormHelperText>}
      </FormControl>
    </div>
  )
}

export default ButtonCheckbox
